import React, { useState } from 'react';
import { Button, Input } from 'antd';
import { SendOutlined } from '@ant-design/icons';

import { dealerHttp } from '@network';
import { Document } from '@types';
import { showAxiosError } from '@utils';
import cls from './DealerDocumentCommentForm.module.css';

interface Props {
  dealerId: number;
  document?: Document;
  setDocument: (document: Document) => void;
  editable: boolean;
}

export const DealerDocumentCommentForm = ({
  dealerId,
  document,
  setDocument,
  editable,
}: Props) => {
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(false);

  if (!document || !editable) return null;

  const onSubmit = async () => {
    if (!comment.trim()) return;
    setLoading(true);
    try {
      const updatedDocument = await dealerHttp.addCommentToDocument({
        dealerId,
        document,
        comment,
      });
      setDocument(updatedDocument);
      setComment('');
    } catch (err: any) {
      showAxiosError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={cls.commentForm}>
      <Input.TextArea
        value={comment}
        onChange={e => setComment(e.target.value)}
        placeholder="Add comment..."
        rows={3}
        onPressEnter={e => {
          if (e.shiftKey) return;
          e.preventDefault();
          onSubmit();
        }}
      />
      <Button
        type="primary"
        icon={<SendOutlined />}
        onClick={onSubmit}
        loading={loading}
        disabled={!comment.trim()}
        className={cls.submitButton}
      >
        Send
      </Button>
    </div>
  );
};

